export default {
    parts: ['container', 'header', 'icon', 'title', 'summary', 'note'],
    baseStyle: {
        container: {},
        header: {
            align: 'center',
            gap: 1,
            mb: 4
        },
        icon: {
            boxSize: 6
        },
        title: {
            textStyle: 'webH3'
        },
        summary: {
            textStyle: 'bodySmRegular',
            mb: 4
        },
        note: {
            textStyle: 'bodySmRegular',
            color: 'webTypo.textSecondary',
            mb: 4
        }
    }
}
